module.exports = __webpack_public_path__ + "static/media/todo.757aaef7.jpg";